import React from 'react';

import SuccessIcon from '@atlaskit/icon/core/migration/check-circle';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import InfoIcon from '@atlaskit/icon/core/migration/information--info';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { B300, G300, R300, Y300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import type { Flag } from '@atlassian/ptc-common';

const flagIconByType: Partial<Record<NonNullable<Flag['type']>, JSX.Element>> = {
	error: <ErrorIcon label="error123" spacing="spacious" color={token('color.icon.danger', R300)} />,
	warning: (
		<WarningIcon label="warning123" spacing="spacious" color={token('color.icon.warning', Y300)} />
	),
	info: (
		<InfoIcon label="info123" spacing="spacious" color={token('color.icon.information', B300)} />
	),
};

const defaultIcon = (
	<SuccessIcon label="winner123" spacing="spacious" color={token('color.icon.success', G300)} />
);

export const getTypeIcon = (type: Flag['type'] = 'normal'): JSX.Element =>
	flagIconByType[type] || defaultIcon;
